/*
 * Copyright (c) 2020. American Express Company
 */

// theirs
import React, { Component, ReactComponentElement } from 'react';

// ours
import LiteralsService from '../../services/literals/LiteralsService';
import { TimePeriod } from 'src/types/time-period';
import { ReportType } from 'src/types/report-type.enum';
import { MetricModel } from 'src/types/metric.model';
import HeroMetric from './HeroMetric';
import { ReportOverviewViewModel } from 'src/types/view-models/report-overview.view.model';
import ReportService from '../../services/report.service';

// styles
import styles from './ReportOverview.module.scss';
import Selectors from 'src/utils/selectors';

export default class ReportOverview extends Component<ReportOverviewViewModel> {
    public override render(): ReactComponentElement<any> {
        const notPast: boolean = this.props.drawerProps.period !== TimePeriod.PAST;
        let report: MetricModel[];
        let value: number | number[];

        switch (this.props.reportType) {
            case ReportType.INCOME_AND_EXPENSE:
                value = ReportService.getIncomeAndExpenseStats(this.props.drawerProps);
                report = [
                    {
                        header: LiteralsService.getLiteral('IncomeExpenseDrawer.incomeMetricTitle', [notPast]),
                        tooltip: LiteralsService.getLiteral('IncomeExpenseDrawer.incomeTooltip', [notPast]),
                        value: value[0]
                    },
                    {
                        header: LiteralsService.getLiteral('IncomeExpenseDrawer.expenseMetricTitle', [notPast]),
                        tooltip: LiteralsService.getLiteral('IncomeExpenseDrawer.expensesTooltip', [notPast]),
                        value: value[1]
                    },
                    {
                        header: LiteralsService.getLiteral('IncomeExpenseDrawer.cashFlowMetricTitle', [notPast]),
                        tooltip: LiteralsService.getLiteral('IncomeExpenseDrawer.cashFlowTooltip', [notPast]),
                        value: value[2]
                    }
                ];
                break;

            case ReportType.ASSET_AND_DEBT:
                value = ReportService.getAssetAndDebtStats(this.props.monteCarlo, this.props.drawerProps);
                report = [
                    {
                        header: LiteralsService.getLiteral('AssetDebtDrawer.assetMetricTitle', [notPast]),
                        tooltip: LiteralsService.getLiteral('AssetDebtDrawer.assetsTooltip', [notPast]),
                        value: Math.round(value[0])
                    },
                    {
                        header: LiteralsService.getLiteral('AssetDebtDrawer.debtMetricTitle', [notPast]),
                        tooltip: LiteralsService.getLiteral('AssetDebtDrawer.debtTooltip', [notPast]),
                        value: Math.round(value[1])
                    },
                    {
                        header: LiteralsService.getLiteral('AssetDebtDrawer.netWorthMetricTitle', [notPast]),
                        tooltip: LiteralsService.getLiteral('AssetDebtDrawer.netWorthTooltip', [notPast]),
                        value: Math.round(value[2])
                    }
                ];
                break;

            default:
                value = ReportService.getNetworthStats(this.props.monteCarlo, this.props.drawerProps);
                report = [
                    {
                        header: LiteralsService.getLiteral('NetWorthDrawer.netWorthMetricTitle', [notPast]),
                        tooltip: LiteralsService.getLiteral('NetWorthDrawer.netWorthTooltip', [notPast]),
                        value: Math.round(value)
                    }
                ];
        }

        return (
            <div className={styles.reportOverview} data-cy={Selectors.PlanAhead.REPORT_OVERVIEW}>
                <div className={styles.topRow}>
                    <HeroMetric metric={report[0]} showChange={this.props.reportType === ReportType.NETWORTH} />
                    {report[1] && <HeroMetric metric={report[1]} showChange={false} tooltipMaxWidth="130px" />}
                </div>
                {report[2] && <HeroMetric metric={report[2]} showChange />}
            </div>
        );
    }
}
